module.exports = __webpack_public_path__ + "static/bank-hankou.f76bac43.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/bank-hankou.png
// module id = 976
// module chunks = 2